import React from "react";
import { useTranslation } from "react-i18next";

const EmployeeReassignedTier = ({ notification }) => {
  const { t } = useTranslation();

  return (
    <>
      <h4 className="notification-title">
        {t("user_change_tier_notification_title")}
      </h4>
      <p className="notification-subtitle">
        {t("user_change_tier_notification_subtitle")}
      </p>
      <p className="subtitle-description">{t("check_your_benefits_prefer")}</p>
    </>
  );
};

export default EmployeeReassignedTier;
